import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '../../types';
import { RootState } from '../store';
import { ROLE_LABELS } from '../../util';

interface AuthState {
  user?: User;
}

const initialState: AuthState = {};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuth: (state) => {
      delete state.user;
      localStorage.clear();
      window.location.reload();
    },
    setUser: (state, action: PayloadAction<User | undefined>) => {
      state.user = action.payload;
    },
  },
});

export const { clearAuth, setUser } = authSlice.actions;

export const selectLoggedIn = (state: RootState) => !!state.auth.user;

export const selectDisplayName = (state: RootState) =>
  state.auth.user?.name || state.auth.user?.username;

export const selectUserAuth = (state: RootState) => state.auth.user;

export const selectUserRole = (state: RootState) => state.auth.user?.role;

export const selectUserName = (state: RootState) => state.auth.user?.username;

export const selectUserRoleLabel = (state: RootState) => {
  const role = selectUserRole(state);
  if (role) {
    return ROLE_LABELS[role];
  }
};

export default authSlice.reducer;
